// extracted by mini-css-extract-plugin
export default {"container":"Disclaimer_container__b7+HW","label":"Disclaimer_label__kb2JY","copy":"Disclaimer_copy__Gls0W"};